import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'transfer',
  templateUrl: './transfer.component.html',
  styleUrls: ['./transfer.component.less'],
})
export class TransferComponent implements OnInit {
  /**
   * 数据源
   */
  @Input() data: Array<object> = [
    { label: '全选', value: '', isAll: true },
    { label: '测试1', value: 1 },
    { label: '测试2', value: 2 },
    { label: '测试3', value: 3 },
    { label: '测试4', value: 4 },
    { label: '测试5', value: 5 },
  ];
  /**
   * 左侧选项模块宽度
   */
  @Input() leftWidth: string = '240px';
  @Input() scrollHeight: string = '130px';
  /**
   * 左侧选项模块title
   */
  @Input() optionsTitle: string = '策略师';

  // tslint:disable-next-line:no-output-native
  @Output() change = new EventEmitter();
  /**
   * 选中的数据
   */
  @Input() nzModel: Array<any> = [];
  /**
   * 双向绑定改变值的方法
   */
  @Output() nzModelChange = new EventEmitter();
  /**
   * 选项模块检索关键字
   */
  optionsSearchKey: string = '';
  /**
   * 结果模块检索关键字
   */
  resultSearchKey: string = '';
  /**
   * 选择的结果
   */
  resultData: any = [];

  constructor() {}

  ngOnInit(): void {}

  /**
   * 检索选项
   */
  searchOptions(): void {}

  /**
   * 检索选择结果
   */
  searchResult(): void {}

  /**
   * 选择options
   * @param option
   */
  checkLabel(option: any): void {
    let resultData = this.resultData;
    let data = [];
    let nzModel = this.nzModel;
    /**
     * 判断是全选
     */
    if (option['isAll'] == true) {
      nzModel = [];
      data = this.data.map((item) => {
        item['checked'] = option['checked'];
        return item;
      });
      if (option['checked'] == false) {
        resultData = [];
        nzModel = [];
      } else {
        for (const item of this.data) {
          if (item['isAll'] == undefined || item['isAll'] == false) {
            resultData.push(item);
            nzModel.push(item['value']);
          }
        }
      }
      this.resultData = [...resultData];
      this.data = [...data];
      this.nzModel = [...nzModel];
    } else {
      if (option['checked'] != false) {
        resultData.push(option);
        nzModel.push(option['value']);
        if (resultData.length == this.data.length - 1) {
          data = this.data.map((item) => {
            if (item['isAll'] == true) {
              item['checked'] = true;
            }
            return item;
          });
          this.data = [...data];
        }
      } else {
        resultData.map((item, index) => {
          if (item['value'] == option['value']) {
            resultData.splice(index, 1);
          }
        });
        nzModel.splice(nzModel.indexOf(option['value']), 1);
        if (resultData.length == 0) {
          data = this.data.map((item) => {
            if (item['isAll'] == true) {
              item['checked'] = false;
            }
            return item;
          });
          this.data = [...data];
        }
      }
      this.resultData = [...resultData];
      this.nzModel = [...nzModel];
    }
    this.nzModelChange.emit(nzModel);
    this.change.emit({ event: 'change', target: resultData });
  }

  /**
   * 清空选择数据
   */
  clear(): void {
    let data: any[];
    data = this.data.map((item) => {
      item['checked'] = false;
      return item;
    });

    this.data = [...data];
    this.resultData = [...[]];
    this.nzModel = [...[]];
    this.nzModelChange.emit([]);
    this.change.emit({ event: 'clear', target: [] });
  }
}
